export const BOOKLOADED = "books/bookLoader";
export const BOOKADD = "books/bookAdd";
export const BOOKEDIT = "books/bookEdit";
export const BOOKUPDATE = "books/bookUpdate";
export const BOOKDELETE = "books/bookDelete";
export const BOOKFILTERFEATURED = "book/featured"
